import { t } from '../../utils/i18n';
import { SCREEN } from '../../utils/constants';
import { procedureDeliveryBucket } from '../../utils/deliveryMode';
import { navigate } from './movePages';
import {
    locations,
    procedures,
    setSelectedLocation,
    phone,
    selectedCountry,
    appUrl,
    setLeadInfo,
    setIsBookAppointment,
    originProcedures,
    surgicalOption,
    setHasLead,
    projectId,
    patientSelected,
    selectedDeliveryMode,
    isBookAppointment, setAccessToken, setOtpAccessToken, form, staffId,
    appointmentChannelId,
    providerId,
    selectedLocation,
    visitorId,
    isFlowForCalendar,
    leadInfo,
    selectedAppointmentUnixTime,
    setLeadTextId,
    categories,
    tempLeadInfo as temporaryLeadInfo,
    setTempLeadInfo,
    setCustomFields,
    customFields,
    scopeProceduresToSelectedLocation,
    setProcedureSelectionType,
} from '../../utils/variables';
import { addProcedure, removeAllProcedures } from '../actions/procedureActions';
import { loginPortal } from '../../services/digitsCodeService';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { sendOTPCodeWithTimer } from '../actions/validateDigitsActions';
import { loadProcedures } from '../../views/components/procedures';
import { loadCategories } from '../../views/components/category';
import { verifyInforListeners } from './verifyInforListenters';
import { registerNewPatientContinueBtnListeners, registerNewPatientInputFieldListeners } from './registerNewPatientListeners';
import { toastError } from '../../views/components/error';
import { handleEditPhone } from '../../views/components/timeSelect';
import { appointmentItemsClickEventHandler } from '../actions/selectTimeActions';
import { shouldTriggerAllQuestionsAfterValidation, loadAllQuestionsFlow } from '../actions/allQuestionsFlow';
import { loadCategoryList } from '../../views/pages/categories';
import { categorySelectionListeners } from './categorySelectionListeners';
import { isHasProcedureBelongToCategory } from '../actions/categoryActions';
import { createLead } from '../../services/leadServices';
import { updateLeadStep } from '../../services/leadServices';
import { handelConsultSummaryBtn, showCategorySelectionForConsultation } from './consultListeners';
import {
    setProcedures as setProceduresVar,
    setCustomFields,
} from '../../utils/variables';
import { openBookAppointment } from './movePages';
import { loadAllQuestionsFlow, shouldShowAllQuestions } from '../actions/allQuestionsFlow';

export function validateDigitsListeners() {
    const allowedKeys = ["Backspace", "Enter", "Tab", "ArrowLeft", "ArrowRight"];

    /* On click enter */
    const screenPhone = document
        .querySelector('.screen--validateDigits');
    if (screenPhone) {
        screenPhone.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !document
                .querySelector('.validateDigitsContinue__btn').classList.contains('disabled')) {
                document
                    .querySelector('.validateDigitsContinue__btn').click();
            }
        });
    }

    /* OTP input fields */
    const validateDigitsDoms = [
        document.getElementById('validateDigits0'),
        document.getElementById('validateDigits1'),
        document.getElementById('validateDigits2'),
        document.getElementById('validateDigits3')];

    const resendOTPBtnDom = document.querySelector('.validateDigits--resend-otp');

    /* on click Continue after input phone number*/
    document
        .querySelector('.validateDigitsContinue__btn')
        .addEventListener('click', async () => {
            const loaderIcon = document.querySelector('.validateDigitsContinue__btn .loader__icon');
            try {
                document
                    .querySelector('.validateDigitsContinue__btn')?.classList.add('disabled');
                document
                    .querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.remove('hidden');
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<img src="${appUrl}/assets/icons/rolling.png" />`);
                }
                if (locations.length > 1 && !isBookAppointment) {
                    navigate(SCREEN.LOCATIONS);
                } else if (locations.length <= 0 && !isBookAppointment) {
                    navigate(SCREEN.LOCATIONS);
                    document.querySelector(
                        '.locations__container .title__wrapper--instant .title__content'
                    ).textContent = t('no_location_found');
                } else {
                    let otpCode = '';
                    validateDigitsDoms.forEach(element => {
                        otpCode += element.value;
                    });
                    const tempLeadInfo = await loginPortal(parsePhoneNumberFromString(phone, selectedCountry).number, otpCode, projectId, visitorId);

                    setAccessToken(tempLeadInfo.data.access_token);
                    setOtpAccessToken(tempLeadInfo.data.access_token);

                    /**
                     * Appointment booking flow after OTP verification.
                     */
                    if (appointmentChannelId) {
                        const collectPatientInfoFirst = form?.appointment_channel?.collect_patient_information_first_before_scheduling;

                        // "Collect patient info first" flow: patient already entered info before OTP.
                        // Create the lead from the saved form data, then check questionnaire, then calendar.
                        if (collectPatientInfoFirst && temporaryLeadInfo) {
                            const res = await createLead(temporaryLeadInfo);
                            const lead = res.data;
                            setLeadInfo(lead);
                            setLeadTextId(lead.text_id);
                            setTempLeadInfo(null);
                            if (lead?.id) {
                                await updateLeadStep(lead.id, 'login', 'true');
                            }

                            // Show questionnaire before calendar if setting is enabled
                            const showQuestionnaireBefore = form?.appointment_channel?.show_questionnaire_before_scheduling;
                            if (showQuestionnaireBefore) {
                                const qualificationFields = Array.isArray(form?.appointment_channel?.qualification_form?.custom_fields)
                                    ? form.appointment_channel.qualification_form.custom_fields
                                    : [];
                                if (qualificationFields.length > 0 && shouldShowAllQuestions()) {
                                    setCustomFields(qualificationFields);
                                    loadAllQuestionsFlow();
                                    return;
                                }
                            }

                            openBookAppointment();
                            return;
                        }

                        // Normal calendar-first flow: go to Verify Information after OTP.
                        const otpLead = tempLeadInfo?.data?.lead || leadInfo;
                        if (otpLead) {
                            const data = {
                                ...otpLead,
                                phone: parsePhoneNumberFromString(phone, selectedCountry).number
                            };
                            setLeadInfo(data);
                            if (data?.text_id) {
                                setLeadTextId(data.text_id);
                            }
                            if (!customFields?.length) {
                                setCustomFields(
                                    form?.appointment_channel?.qualification_form?.custom_fields || []
                                );
                            }
                            if (data?.id) {
                                await updateLeadStep(data.id, 'login', 'true');
                            }
                            navigate(SCREEN.VERIFY_INFORMATION);
                            verifyInforListeners(data);
                            return;
                        }
                    }

                    const { is_phone_otp_enabled } = form || {}
                    const isCategoryEnabled = form?.appointment_channel?.enable_category_selection;
                    
                    if (is_phone_otp_enabled) {
                        setLeadInfo(tempLeadInfo?.data?.lead);
                        setLeadTextId(tempLeadInfo?.data?.lead?.text_id);
                        
                        if (isCategoryEnabled && temporaryLeadInfo) {
                            const proceduresToShow = appointmentChannelId 
                                ? (form?.appointment_channel?.procedures || procedures)
                                : procedures;
                            
                            if (showCategorySelectionForConsultation(proceduresToShow)) {
                                return;
                            }
                            
                            if (proceduresToShow.length > 0) {
                                setProceduresVar(proceduresToShow);
                                loadCategories(proceduresToShow);
                                loadProcedures(proceduresToShow);
                                navigate(SCREEN.SEE_ALL_SERVICES);
                                return;
                            }
                        }
                        
                        if (temporaryLeadInfo) {
                            await createLead(temporaryLeadInfo);
                            setTempLeadInfo(null);
                        }
                        handelConsultSummaryBtn()
                        return;
                    }

                    const data = tempLeadInfo?.data?.lead;
                    if (data) {
                        setLeadInfo(data);
                        setSelectedLocation(selectedLocation || locations[0].id);
                        setLeadTextId(data.text_id);

                        if (shouldTriggerAllQuestionsAfterValidation()) {
                            loadAllQuestionsFlow();
                        } else {
                            navigate(SCREEN.VERIFY_INFORMATION);
                            verifyInforListeners(data);
                        }
                    } else {
                        setHasLead(true);
                        registerNewPatientInputFieldListeners();
                        registerNewPatientContinueBtnListeners();
                        navigate(SCREEN.REGISTER_NEW_PATIENT);
                    }
                    validateDigitsDoms.forEach(element => {
                        element.value = '';
                    });
                    validateDigitsDoms[0].focus();
                }
            } catch (error) {
                validateDigitsDoms.forEach(element => {
                    element.value = '';
                });
                validateDigitsDoms[0].focus();
                if ((error.response?.data?.message || error) && error.response?.status === 500) {
                    setHasLead(true);
                    setAccessToken(form.token);

                    if (shouldTriggerAllQuestionsAfterValidation()) {
                        loadAllQuestionsFlow();
                    } else {
                        registerNewPatientInputFieldListeners();
                        registerNewPatientContinueBtnListeners();
                        navigate(SCREEN.REGISTER_NEW_PATIENT);
                    }
                } else {
                    toastError(error.response?.data?.message);
                }
            } finally {
                document
                    .querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled--noneOpacity');
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML('beforeend', `<i class="ri-arrow-right-line"></i>`);
                }
                document
                    .querySelector('.validateDigitsContinue__btn .loading__wrapper')?.classList.add('hidden');
                if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                    document.querySelector('.validateDigitsContinue__btn')?.classList.remove('disabled');
                }
            }
        });

    let pageOTPInputContinueBtn = document.querySelector('.validateDigitsContinue__btn');

    /* OTP input field validation - Only accept number */
    validateDigitsDoms.forEach((element, index) => {
        element.addEventListener('input', (event) => {
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                pageOTPInputContinueBtn?.classList.remove('disabled');
            } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) {
                pageOTPInputContinueBtn?.classList.add('disabled');
            }
            if (event.data?.length === 1 && validateDigitsDoms[index + 1]) {
                validateDigitsDoms[index + 1].focus();
                return;
            }
            if (element.id === 'validateDigits0' && element.value.length > 1) {
                for (let i = 0; i < validateDigitsDoms.length; i++) {
                    if (!validateDigitsDoms[i].value) {
                        validateDigitsDoms[i].value = event.target.value.split('')[event.target.value.length - 1];
                        element.value = event.target.value.split('')[0];
                        break;
                    }
                }
                if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                    pageOTPInputContinueBtn?.classList.remove('disabled');
                } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) {
                    pageOTPInputContinueBtn?.classList.add('disabled');
                }
                return;
            }
        });

        element.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                event.stopPropagation();
            }
            if ((isNaN(event.key) || event.key === " ") && !event.ctrlKey && !allowedKeys.includes(event.key)) {
                event.preventDefault();
                return;
            }
            if (event.key === "Backspace") {
                event.preventDefault();
                if (!validateDigitsDoms[index].value && validateDigitsDoms[index - 1]) {
                    validateDigitsDoms[index - 1].focus();
                }
                validateDigitsDoms[index].value = "";
                if (!pageOTPInputContinueBtn?.classList.contains('disabled')) {
                    pageOTPInputContinueBtn?.classList.add('disabled');
                }
                return;
            } else if (element.id === 'validateDigits3' && event.key === "Tab") {
                event.preventDefault();
            }
        });

        element.addEventListener('beforeinput', (event) => {
            if (event.data?.length > 1) {
                event.preventDefault();
                let eventDataArr = event.data.split('').filter(value => { return !isNaN(value) && value !== " "; });
                if (eventDataArr.length > 4) {
                    eventDataArr = eventDataArr.slice(0, 4);
                }
                eventDataArr.forEach((val, pos) => {
                    validateDigitsDoms[pos].value = val;
                    if (validateDigitsDoms[pos + 1]) {
                        validateDigitsDoms[pos + 1].focus();
                    }
                });
            } else if (element.value && event.data) {
                event.preventDefault();
                element.value = event.data;
                if (validateDigitsDoms[index + 1]) {
                    validateDigitsDoms[index + 1].focus();
                }
            }
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                pageOTPInputContinueBtn?.classList.remove('disabled');
            } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) {
                pageOTPInputContinueBtn?.classList.add('disabled');
            }
        });

        element.addEventListener('paste', (event) => {
            const paste = (event.clipboardData || window.clipboardData).getData('text').replaceAll(' ', '').split("");
            event.preventDefault();
            validateDigitsDoms.forEach((element, index) => {
                if (paste[index] && !isNaN(paste[index])) {
                    element.value = paste[index];
                }
            });
            if (validateDigitsDoms[0].value && validateDigitsDoms[1].value && validateDigitsDoms[2].value && validateDigitsDoms[3].value) {
                pageOTPInputContinueBtn?.classList.remove('disabled');
                validateDigitsDoms[3].focus();
            } else if (!pageOTPInputContinueBtn?.classList.contains('disabled')) {
                pageOTPInputContinueBtn?.classList.add('disabled');
            }
        });
    });

    resendOTPBtnDom.addEventListener('click', async () => {
        sendOTPCodeWithTimer();
    });

    const { is_phone_otp_enabled } = form || {}
    if (isFlowForCalendar || is_phone_otp_enabled) {

        const editPhoneBtn = document.querySelector('.edit-phone-btn');
        if (editPhoneBtn) {
            editPhoneBtn.style.display = 'inline';
            editPhoneBtn.addEventListener('click', handleEditPhone);
        }
    }
}

export const goToServices = () => {
    document.querySelector('.seeServices__container')?.classList.add('procedure-in-booking');
    setIsBookAppointment(true);
    let filterProcedures = (staffId ? procedures : originProcedures).filter(i => {
        if (surgicalOption === null) {
            return i?.online_booking;
        }
        return (!!i?.surgical === surgicalOption) && i?.online_booking;
    });

    if (appointmentChannelId && form?.appointment_channel?.procedures?.length > 1) {

        filterProcedures = form?.appointment_channel?.procedures.filter(i => {
            if (surgicalOption === null) {
                return i?.online_booking;
            }
            return (!!i?.surgical === surgicalOption) && i?.online_booking;
        });

        const hostType = form?.appointment_channel?.host || 'one_on_one';
        const staffsOfAppointmentChannel = form?.appointment_channel?.staffs?.filter(staff => staff?.online_booking);
        const staffCount = staffsOfAppointmentChannel?.length || 0;
        const canChooseStaff = (hostType === 'one_on_one' && staffCount > 1) ||
            (hostType !== 'one_on_one' && form?.appointment_channel?.visitor_can_choose_the_staff);

        if (canChooseStaff && providerId > 0) {
            const proceduresStaffIds = procedures?.map(i => i.id);
            filterProcedures = filterProcedures.filter(f => proceduresStaffIds.includes(f.id))
        }

    }

    if (patientSelected) {
        filterProcedures = filterProcedures.filter(f => {
            if (patientSelected === 'all') {
                return ['returning_patient', "new_patient", "new_and_returning_patient"].includes(f.type);
            }
            return [patientSelected, "new_and_returning_patient"].includes(f.type);
        });
    }

    // Filter the service list by the chosen delivery mode when the channel has
    // delivery_mode_selection on. Virtual → fully_virtual services; Phone →
    // phone_consultation services; In-Person → everything else.
    if (selectedDeliveryMode) {
        // MODE-LESS inquiry tiles (online_booking_option === 'inquiry' with no
        // service_delivery_mode, e.g. an "Others" option) belong to every
        // delivery mode. An inquiry tile that DOES carry a mode is that mode's
        // service only — it must not leak into the other modes' menus
        // (Executive Plastic 692: the in-person inquiry tile appeared on the
        // Phone menu).
        filterProcedures = filterProcedures.filter(f =>
            (f?.online_booking_option === 'inquiry' && !f?.service_delivery_mode)
                || procedureDeliveryBucket(f) === selectedDeliveryMode
        );

        // The chosen mode has no bookable services at the selected location
        // (e.g. in-person consults pivot-scoped to another location). Don't
        // render an empty menu — or a menu of only inquiry tiles — thank the
        // visitor instead; THE_END's updateStep() files the lead for
        // front-desk follow-up.
        const bookable = scopeProceduresToSelectedLocation(filterProcedures)
            .filter(f => f?.online_booking_option !== 'inquiry');
        if (bookable.length === 0) {
            const notifyText = document.querySelector('.endScreen__container .notify-text');
            if (notifyText) notifyText.textContent = t('inquiry_fallback_message');
            navigate(SCREEN.THE_END);
            return;
        }
    }

    loadProcedures(filterProcedures);
    loadCategories(filterProcedures);
    document.querySelectorAll('.procedure__price-duration')?.forEach((j) => j.classList.add('procedure__price-duration--show'));

    const enableCategorySelection = form?.appointment_channel?.enable_category_selection;

    if (enableCategorySelection && filterProcedures.length > 1) {
        const filteredCategories = categories.filter((category) =>
            isHasProcedureBelongToCategory(category, filterProcedures)
        );

        if (filteredCategories.length > 0) {
            loadCategoryList(filteredCategories);
            categorySelectionListeners();
            navigate(SCREEN.CATEGORIES);
            return;
        }
    }

    // Exactly one service survived the filters above (patient type / delivery
    // mode / provider) — don't make the visitor tick a one-item list. Select it
    // and run the same Continue path the button would. We deliberately DON'T
    // navigate to SEE_ALL_SERVICES, so Back from the next screen returns to the
    // previous real question instead of a pointless single-option picker.
    // Skipped for tiles whose click handler does something other than select
    // (inquiry / custom_booking_url) or that need a second choice (add-ons).
    const onlyProcedure = filterProcedures.length === 1 ? filterProcedures[0] : null;
    const hasAddons = onlyProcedure?.procedure_addons?.some((a) => !a.deleted_at);
    if (
        onlyProcedure
        && onlyProcedure.online_booking_option !== 'inquiry'
        && !onlyProcedure.custom_booking_url
        && !hasAddons
    ) {
        // navigate(SEE_ALL_SERVICES) normally does these two in showScreen().
        setProcedureSelectionType(
            form?.appointment_channel?.selection_type || form.selection_type
        );
        removeAllProcedures();
        addProcedure(onlyProcedure.id);
        document.querySelector('.procedureContinue__btn')?.click();
        return;
    }

    navigate(SCREEN.SEE_ALL_SERVICES);
}
